import AutorenewIcon from '@material-ui/icons/Autorenew';

import List from './List';

export default {
  list: List,
  icon: AutorenewIcon,
};
